// extracted by mini-css-extract-plugin
export var drawerContent = "_2z-0";
export var valueBlock = "_2z-1";
export var valueBlockFrom = "_2z-2 _2z-1";
export var valueBlockTo = "_2z-3 _2z-1";